import { html, svg } from 'lit';
const path = svg `<path d="M15.5 9H4.5C4.21875 9 4 9.25 4 9.5V10.5C4 10.7812 4.21875 11 4.5 11H15.5C15.75 11 16 10.7812 16 10.5V9.5C16 9.25 15.75 9 15.5 9Z"/>`;
export default html `<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">${path}</svg>`;
//# sourceMappingURL=minus.js.map